<template>
  <benefits-wrapper-fi v-bind="props">
    <slot />
  </benefits-wrapper-fi>
</template>

<script setup lang="ts">
import type { Placeholder } from '@/sitecoreState';

import BenefitsWrapperFi from './BenefitsWrapperFi.vue';
import type { PlaceholderProps } from './ProductBenefitsFi.vue';

const props = defineProps<{
  placeholderProps: PlaceholderProps;
  placeholder: Placeholder;
}>();
</script>
